import type { ProductPlan } from '@/features/products/types';
import { trialDurationPhrase } from '@/features/payments/domain/pricing';
import { formatMoney } from '@/shared/lib/money';

const PRIORITY_ONE_TIME_DISCLAIMER =
  'This is a one-time add-on to your MoneyFox plan. No recurring charges. Your priority filing will activate instantly after checkout. MoneyFox will fast-track your review, move you to the front of the queue, and get your eligible claims filed within 24 hours.';

/**
 * Priority Access legal line. Recurring copy only when the plans service
 * explicitly marks the add-on with `one_time: false` (boostgram).
 */
export function priorityOfferDisclaimer(plan: ProductPlan | undefined): string {
  if (!plan || plan.oneTime !== false) return PRIORITY_ONE_TIME_DISCLAIMER;

  const renewal = formatMoney(plan.recurringPrice ?? plan.price, plan.currency);

  if (plan.recurringPrice == null) {
    return `Your subscription will automatically renew at ${renewal} per month unless you cancel before the renewal date.`;
  }

  const trial = trialDurationPhrase(plan).trim();
  const today = formatMoney(plan.price, plan.currency);
  const trialLabel = trial ? `${trial} ` : '';
  return `Your ${trialLabel}trial costs ${today}. After the trial ends, your subscription will automatically renew at ${renewal} per month unless you cancel before the renewal date.`;
}
